const PopularSearch = () => {
  return (
    <div className="popular-searches" data-aos="fade-up" data-aos-delay="1000">
      <span className="title" style={{color: 'white', fontSize: '1.3em'}}>Popular Searches : </span>
      <a href="#"  style={{color: 'white',fontSize: '1.1em'}}>Designer</a>, <a href="#" style={{color: 'white', fontSize: '1.1em'}}>Developer</a>, <a href="#" style={{color: 'white', fontSize: '1.1em'}}>Web</a>,
      <a href="#" style={{color: 'white', fontSize: '1.1em'}}> IOS</a>, <a href="#" style={{color: 'white', fontSize: '1.1em'}}>PHP</a>, <a href="#" style={{color: 'white', fontSize: '1.1em'}}>Senior Engineer</a>
    </div>
  );
};

export default PopularSearch;
